module.exports = __webpack_public_path__ + "img/serve9.abfd90ac.png";